import { Logo } from "@/components/Logo";

export const AuthShell = ({ children }) => (
  <div className="flex min-h-screen bg-paper">
    <aside className="paper-grain relative hidden w-[44%] flex-col justify-between border-r border-paper-border bg-paper-subtle p-12 lg:flex">
      <Logo />
      <div>
        <p className="eyebrow">Resume &amp; cover letter studio</p>
        <h2 className="mt-4 font-serif text-5xl leading-[1.05] text-ink">Your work,<br />on one <em className="text-thread">perfect</em> page.</h2>
        <p className="mt-6 max-w-sm text-ink-soft">Build for free, sharpen every line with AI and tailor it to each job. Pay only when you download.</p>
      </div>
      <p className="font-mono text-xs text-taupe">© {new Date().getFullYear()} Pitchpaper</p>
    </aside>
    <main className="flex flex-1 flex-col items-center justify-center gap-8 px-4 py-10">
      <div className="lg:hidden"><Logo /></div>
      {children}
    </main>
  </div>
);
